export const CreateRoomDialogTestIds = {
  formCreateroom: 'form_createroom',
  fieldPrivacyDropdown: 'field_privacy_dropdown',
  privacyRoomSelect: 'privacy_room_select',
  privateOption: 'private_option',
  publicOption: 'public_option',
  fieldName: 'field_name',
  fieldNameInput: 'field_name_input',
  fieldAlias: 'field_alias',
  fieldAliasInput: 'field_alias_input',
  fieldTopic: 'field_topic',
  fieldTopicInput: 'field_topic_input',
  buttonCancel: 'button_cancel',
  buttonContinue: 'button_continue',
  toggleRoomtype: 'toggle_roomtype'
} as const;
